const TABLE_PREFERENCES_KEY = 'mercury_table_prefs';

type TablePreferences = Record<string, Record<string, Record<string, string>>>;

/**
 * Get a user's saved filter/sort values for a given table.
 * Returns null when nothing has been saved yet.
 */
export function getTablePreference(
  userId: string,
  tableKey: string
): Record<string, string> | null {
  try {
    const data = localStorage.getItem(TABLE_PREFERENCES_KEY);
    const prefs: TablePreferences = data ? JSON.parse(data) : {};
    return prefs[userId]?.[tableKey] ?? null;
  } catch (error) {
    console.error('Error reading table preferences from localStorage:', error);
    return null;
  }
}

/**
 * Save a user's filter/sort values for a given table.
 */
export function setTablePreference(
  userId: string,
  tableKey: string,
  values: Record<string, string>
): void {
  try {
    const data = localStorage.getItem(TABLE_PREFERENCES_KEY);
    const prefs: TablePreferences = data ? JSON.parse(data) : {};

    if (!prefs[userId]) {
      prefs[userId] = {};
    }

    prefs[userId][tableKey] = values;
    localStorage.setItem(TABLE_PREFERENCES_KEY, JSON.stringify(prefs));
  } catch (error) {
    console.error('Error saving table preferences to localStorage:', error);
  }
}
